// extracted by mini-css-extract-plugin
module.exports = {"iconLink":"styles__iconLink___1TjEn","svg":"styles__svg___21tSO"};